import { Injectable } from "@angular/core";
import { Inspection } from "../../_objects/inspection";
import { LoginUserService } from "./login-user.service";

@Injectable({
  providedIn: "root"
})
export class UserPermissionsService {
  isAdminRole = false;
  isInspectionOwner = false;
  isInspector = false;

  constructor(private loginUserService: LoginUserService) {}

  updateUserProperties(inspection: Inspection): void {
    this.isAdminRole = this.loginUserService.isAdminRole();
    this.isInspectionOwner = this.loginUserService.userId === inspection.createdBy;
    this.isInspector = inspection.inspectors?.some((inspector) => inspector.id === this.loginUserService.userId) ?? false;
  }
}
